import { createSlice } from "@reduxjs/toolkit";

import { createApiThunk, updateState } from "./utilityFunction"

// Initial State
const initialState = {
    fetchSubMenu: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
    saveSubMenu: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
};

// Async Thunk for Fetching Setting Data
export const fetchSubMenuData = createApiThunk("SubMenu", "fetch")
export const saveSubMenuData = createApiThunk("SubMenu", "save")

// Slice
const subMenuSlice = createSlice({
    name: "submenu",
    initialState,

    reducers: {
        resetSubmenuState: (state, action) => {
            const type = action.payload; // Assuming the type is passed in the action's payload

            if (type === "fetch") {
                state.fetchSubMenu = {
                    ...state.fetchSubMenu, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            } else if (type === "save") {
                state.saveSubMenu = {
                    ...state.saveSubMenu, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            }
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchSubMenuData.pending, (state) => updateState(state, "pending", "fetchSubMenu"))
            .addCase(fetchSubMenuData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "fetchSubMenu", action.payload.data))
            .addCase(fetchSubMenuData.rejected, (state, action) =>
                updateState(state, "rejected", "fetchSubMenu", action.payload))
            // Save data
            .addCase(saveSubMenuData.pending, (state) => updateState(state, "pending", "saveSubMenu"))
            .addCase(saveSubMenuData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "saveSubMenu", action.payload.data))
            .addCase(saveSubMenuData.rejected, (state, action) =>
                updateState(state, "rejected", "saveSubMenu", action.payload));
    },
});

export const { resetSubmenuState } = subMenuSlice.actions;
export default subMenuSlice.reducer;
